import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Switch from '@mui/material/Switch';
import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { MuiColorInput, MuiColorInputFormat } from 'mui-color-input';
import { useEffect, useState } from 'react';
import InputTextAreaAutosize from 'src/components/common/field/InputTextAreaAutosize';
import BtnGradient from 'src/components/common/button/BtnGradient';
import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { useNotify } from 'src/context/ContextNotify';

const Index = () => {
  const notifyContext = useNotify();
  const [data, setData] = useState<any>([]);
  const [minTimes, setMinTimes] = useState<any>([]);
  const format: MuiColorInputFormat = 'hex';

  const getSetting = async () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      getAPI(`/setting/site?token=${token}`)
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setData(res.data.items);
            setMinTimes(res.data.mintimes);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    const modifiedData = data.map((item: any) => {
      if (item.cfg === name) {
        return { ...item, value: value };
      }
      return item;
    });
    setData(modifiedData);
  };

  const handleBgColorChange = (newValue: string) => {
    const modifiedData = data.map((item: any) => {
      if (item.cfg === 'bgcolor') {
        return { ...item, value: newValue };
      }
      return item;
    });
    setData(modifiedData);
  };

  const handleFontColorChange = (newValue: string) => {
    const modifiedData = data.map((item: any) => {
      if (item.cfg === 'fontcolor') {
        return { ...item, value: newValue };
      }
      return item;
    });
    setData(modifiedData);
  };

  const handlePrimaryColorChange = (newValue: string) => {
    const modifiedData = data.map((item: any) => {
      if (item.cfg === 'primarybuttoncolor') {
        return { ...item, value: newValue };
      }
      return item;
    });
    setData(modifiedData);
  };

  const handleTextAreaChange =
    (name: string) => (id: number | string | number[] | null) => {
      const modifiedData = data.map((item: any) => {
        if (item.cfg === name) {
          return { ...item, value: id };
        }
        return item;
      });
      setData(modifiedData);
    };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const modifiedData = data.map((item: any) => {
      if (item.cfg === 'termsonoff') {
        return { ...item, value: event.target.checked ? 'ON' : 'OFF' };
      }
      return item;
    });
    setData(modifiedData);
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const modifiedData = data.map((item: any) => {
      if (item.cfg === 'mintime') {
        return { ...item, value: event.target.value };
      }
      return item;
    });
    setData(modifiedData);
  };

  const handleSave = () => {
    try {
      const token = getToken();
      postAPI(`/setting/site-save?token=${token}`, data).then((res) => {
        if (res && res.code === 200) {
          notifyContext.setNotifyMessage({
            show: true,
            message: '設定を変更しました',
            type: 'success',
          });
        }
        if (res.code === 501 || res.code === 500) {
          notifyContext.setNotifyMessage({
            show: true,
            message: res.msg || 'Failed to post data',
            type: 'error',
          });
        }
      });
    } catch (error) {
      console.error('Failed to post data:', error);
      return;
    }
  };
  return (
    <Stack>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none',
          width: '100%',
          height: '100%',
        }}
      >
        <Table
          sx={{
            minWidth: 470,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '6px',
            },
          }}
          aria-label='simple table'
        >
          <TableBody sx={{ '&.MuiTableBody-root th': { fontWeight: 700 } }}>
            {data.map((item: any, index: number) => {
              return (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
                      py: '16px',
                      borderBottom: '1px solid #F3F3F3',
                    },
                  }}
                >
                  <TableCell component={'th'}>{item.cfgname}</TableCell>
                  <TableCell>
                    {(item.cfg === 'clinic' ||
                      item.cfg === 'liffid' ||
                      item.cfg === 'reserveurl') && (
                      <OutlinedInput
                        // error={!errors.fullname}
                        placeholder={'入力してください'}
                        sx={{
                          fontSize: '14px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#BDBDBD',
                          },
                          '& .MuiInputBase-input': { padding: '8px 14px' },
                          '& input::placeholder': {
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#CCD1D9',
                            opacity: 1,
                          },
                          backgroundColor: 'primary.light',
                          width: '100%',
                        }}
                        inputProps={{
                          sx: {
                            backgroundColor: 'primary.light',
                          },
                        }}
                        name={item.cfg}
                        value={item.value}
                        onChange={(event) => handleInputChange(event)}
                      />
                    )}
                    {item.cfg === 'bgcolor' && (
                      <MuiColorInput
                        format={format}
                        value={item.value || ''}
                        onChange={handleBgColorChange}
                        isAlphaHidden
                        size='small'
                      />
                    )}
                    {item.cfg === 'fontcolor' && (
                      <MuiColorInput
                        format={format}
                        value={item.value || ''}
                        onChange={handleFontColorChange}
                        isAlphaHidden
                        size='small'
                      />
                    )}
                    {item.cfg === 'primarybuttoncolor' && (
                      <MuiColorInput
                        format={format}
                        value={item.value || ''}
                        onChange={handlePrimaryColorChange}
                        isAlphaHidden
                        size='small'
                      />
                    )}
                    {(item.cfg === 'editableday' ||
                      item.cfg === 'cancelday') && (
                      <OutlinedInput
                        // error={!errors.fullname}
                        placeholder={'入力してください'}
                        sx={{
                          fontSize: '14px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#BDBDBD',
                          },
                          '& .MuiInputBase-input': { padding: '8px 14px' },
                          '& input::placeholder': {
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#CCD1D9',
                            opacity: 1,
                          },
                          backgroundColor: 'primary.light',
                          width: '100%',
                        }}
                        inputProps={{
                          sx: {
                            backgroundColor: 'primary.light',
                          },
                        }}
                        name={item.cfg}
                        value={item.value}
                        type='number'
                        onChange={(event) => handleInputChange(event)}
                      />
                    )}
                    {item.cfg === 'terms' && (
                      <InputTextAreaAutosize
                        value={item.value}
                        onChange={handleTextAreaChange(item.cfg)}
                        width='100%'
                        height='104px'
                      />
                    )}
                    {item.cfg === 'termsonoff' && (
                      <FormControlLabel
                        value={item.value}
                        control={
                          <Switch
                            color='primary'
                            onChange={(e) => handleSwitchChange(e)}
                            checked={item.value === 'ON'}
                          />
                        }
                        label={''}
                        sx={{
                          '& .MuiFormControlLabel-label': { fontSize: '14px' },
                        }}
                      />
                    )}
                    {item.cfg === 'mintime' && (
                      <RadioGroup
                        row
                        aria-labelledby='demo-controlled-radio-buttons-group'
                        name={item.cfg}
                        value={item.value}
                        onChange={handleRadioChange}
                      >
                        {minTimes.map((min: any, idx: number) => {
                          return (
                            <FormControlLabel
                              key={idx}
                              value={min.value}
                              control={<Radio />}
                              label={min.label}
                            />
                          );
                        })}
                      </RadioGroup>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack direction={'row'} spacing={'20px'} mt={'32px'}>
        <BtnGradient text='更新' handleButtonClick={handleSave} />
      </Stack>
    </Stack>
  );
};

export default Index;
